import {
  Box,
  AppBar,
  Toolbar,
  styled,
  IconButton,
  Typography,
  Grid,
} from '@mui/material';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import Toggle from 'src/components/Home/Toggle';
import Logo from 'src/components/Logo';

interface PropsT {
  toggleMobileSidebar: () => void;
  toggleSidebar: () => void;
}

const Header = ({ toggleMobileSidebar, toggleSidebar }: PropsT) => {
  const AppBarStyled = styled(AppBar)(({ theme }) => ({
    boxShadow: 'none',
    background: theme.palette.background.default,
    justifyContent: 'center',
    backdropFilter: 'blur(4px)',
    // [theme.breakpoints.up('sm')]: {
    //   borderBottom: `2px solid ${theme.palette.divider}`,
    // },
    [theme.breakpoints.up('lg')]: {
      minHeight: '120px',
    },
  }));

  const ToolbarStyled = styled(Toolbar)(({ theme }) => ({
    width: '100%',
    color: theme.palette.text.secondary,
  }));

  return (
    <AppBarStyled position="sticky">
      <Grid
        sx={{
          backgroundColor: '#001B2F',
          display: { xs: 'block', sm: 'none' },
        }}
      >
        <Box paddingBottom={'12px'}>
          <Logo imgH={50} nameH={37} row={true} />
        </Box>
      </Grid>
      <ToolbarStyled>
        <IconButton
          color="inherit"
          aria-label="menu"
          onClick={toggleMobileSidebar}
          sx={{
            display: {
              xs: 'none',
              sm: 'inline',
              lg: 'none',
            },
          }}
        >
          <MenuRoundedIcon />
        </IconButton>
        <Box flexGrow={1} sx={{ px: 1 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              sx={{
                display: { xs: 'none', sm: 'block' },
                fontSize: { sm: '40px', xs: '19px' },
                fontFamily: 'Space Grotesk',
                fontWeight: '600',
                color: 'black',
              }}
            >
              RÍOS DE CHILE
            </Typography>
            <Typography
              sx={{
                display: { xs: 'block', sm: 'none' },
                fontSize: { sm: '40px', xs: '19px' },
                fontFamily: 'Space Grotesk',
                fontWeight: '600',
                color: 'black',
              }}
            >
              Ríos de Chile
            </Typography>
            <Toggle />
          </Box>
        </Box>
      </ToolbarStyled>
    </AppBarStyled>
  );
};

export default Header;
